import { useState } from 'react'
import {
  discordActivityLabel,
  discordLabel,
  type DiscordActivity,
  type DiscordPresence,
} from '../lib/discord'

function ActivityImage({ activity }: { activity: DiscordActivity }) {
  const [failed, setFailed] = useState(false)
  return (
    <span className="activity-image" aria-hidden="true">
      {activity.imageUrl && !failed ? (
        <img src={activity.imageUrl} alt="" loading="lazy" onError={() => setFailed(true)} />
      ) : (
        activity.name.slice(0, 1).toUpperCase()
      )}
    </span>
  )
}

export function DiscordStatus({ presence }: { presence: DiscordPresence }) {
  const summary = discordLabel({ ...presence, activities: undefined })
  return (
    <section className="discord-status" aria-label="Discord presence">
      <span className="discord-status__line">
        <span className={`presence-dot presence-dot--${presence.state}`} aria-hidden="true" />
        {summary}
      </span>
      {presence.activities?.length ? (
        <ul aria-label="Discord activities">
          {presence.activities.map((activity, index) => (
            <li key={`${activity.type}-${activity.name}-${index}`}>
              <ActivityImage activity={activity} />
              <span>{discordActivityLabel(activity)}</span>
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  )
}
